export default "/images/kamurj_bank.png?c818e4a5bc0d8a41e268f66791185d54";